// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/Users/guanwenchao/Documents/ChatGPT/h5自建站/node_modules/.pnpm/@umijs+runtime@3.5.43_react@16.14.0/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/LoadingCp';

export function getRoutes() {
  const routes = [
  {
    "exact": false,
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__index' */'@/layouts/index'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/",
        "redirect": "/work",
        "exact": true
      },
      {
        "path": "/work",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__home' */'/Users/guanwenchao/Documents/ChatGPT/h5自建站/apps/builder/src/pages/home'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/editor",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__editor' */'/Users/guanwenchao/Documents/ChatGPT/h5自建站/apps/builder/src/pages/editor'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/ide",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ide' */'/Users/guanwenchao/Documents/ChatGPT/h5自建站/apps/builder/src/pages/ide'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/help",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__help' */'/Users/guanwenchao/Documents/ChatGPT/h5自建站/apps/builder/src/pages/help'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/login",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__login' */'/Users/guanwenchao/Documents/ChatGPT/h5自建站/apps/builder/src/pages/login'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/mobileTip",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mobileTip' */'/Users/guanwenchao/Documents/ChatGPT/h5自建站/apps/builder/src/pages/mobileTip'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/preview",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__editor__preview' */'/Users/guanwenchao/Documents/ChatGPT/h5自建站/apps/builder/src/pages/editor/preview'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/admin",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__admin' */'/Users/guanwenchao/Documents/ChatGPT/h5自建站/apps/builder/src/pages/admin'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/p/:slug",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__public' */'/Users/guanwenchao/Documents/ChatGPT/h5自建站/apps/builder/src/pages/public'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
